import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const dashboardData = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/GetDashboardData', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const ExpandDashboardData = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/ExpandDashboardData', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const DeliveryReturnRatio = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/DeliveryReturnRatio', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const ReturnReasons = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/ReturnReasons', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
} 

export const BusinessSummary = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/BusinessSummary', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
} 

export const WithinTATDeliveryInprocess = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/WithinTATDeliveryInprocess', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
} 


export const GetDashboardFinancials = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/GetDashboardFinancials', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}

export const GetDashboardCardData = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/User/GetDashboardCardData', data,
            {
                cancelToken: source.token,
                headers: {
                    key: ApiKey,
                }
            }
        );
        return rs.data;
    } catch (e) {
        console.log(e);
        return { sts: 1, msg: e };
    }
}


export const IsActiveUser = async (id, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/UserManagement/IsActiveUser?id=' + id,
        {
            cancelToken: source.token,
            headers: {
                key: ApiKey,
            }
        }
    );
    return rs.data;

    } catch(e) {
        console.log(e);
        return {sts: 2, msg: e};
    }
}

export const CheckCODAmountLimit = async (accountNo, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/UserManagement/CheckCODAmountLimit?accountNo=' + accountNo,
        {
            cancelToken: source.token,
            headers: {
                key: ApiKey,
            }
        }
    );
    return rs.data;

    } catch(e) {
        console.log(e);
        return {sts: 2, msg: e};
    }
}

export const CheckCODWeightLimit = async (accountNo, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/UserManagement/CheckCODWeightLimit?accountNo=' + accountNo,
        {
            cancelToken: source.token,
            headers: {
                key: ApiKey,
            }
        }
    );
    return rs.data;

    } catch(e) {
        console.log(e);
        return {sts: 2, msg: e};
    }
}

export const getUserTilesById = async (id, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/UserTiles/' + id, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey            
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getAllTiles = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/User/GetAllTiles', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey            
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const updateUserTiles = async (data) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/user/UpdateUserTiles', data, {
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e.toString() };
    }
}